import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track page view for analytics
    trackPageView(pathname, document.title);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
